import loadable from '@loadable/component';

export const ViewPdfFilePageLoadable = loadable(
  () => import('./ViewPdfFilePage'),
  { resolveComponent: (module) => module.ViewPdfFilePage },
);
